module.exports = __webpack_public_path__ + "img/9788996697022.24c8e132.jpg";